import ProductDelete from './ProductDelete'
export {ProductDelete}
export default ProductDelete
